import React from 'react'
import { Link, useHistory } from 'react-router-dom';
import useCurrentLocale from '../../hooks/useLanguage';


export default function GoBack() {
    const lang = useCurrentLocale();

    return (
      <div>
        <Link className="back-btn" to={`/${lang}/menu${window.location.search}`}>
          <i className="ri-arrow-left-s-line arrow-dir"></i>
        </Link>
      </div>
    );
}
